<ng-container *ngIf="countySelection.Statewide">
	<div>Statewide</div>
</ng-container>
<ng-container *ngIf="!countySelection.Statewide">
	<div *ngFor="let county of countySelection.Counties">
		{{county.name}}
	</div>
</ng-container>